import { render, staticRenderFns } from "./RecruitmentAgent.vue?vue&type=template&id=3c4fbcb6&scoped=true"
import script from "./RecruitmentAgent.vue?vue&type=script&lang=js"
export * from "./RecruitmentAgent.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentAgent.vue?vue&type=style&index=0&id=3c4fbcb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4fbcb6",
  null
  
)

export default component.exports